export default __webpack_public_path__ + "static/6 - Bojler vízkőtlenítése-980ce8cc9b5bedca7a22300aa398c2ea.jpg";